import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=522bd4ee"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports